import type { MessageDescriptor } from '@lingui/core';

import { ApiHttpError } from '@/shared/api/client';
import { LIST_VIEW_ERROR_MESSAGES, LIST_VIEW_MESSAGES } from '@/shared/config/listViewMessages';

/**
 * Selects the message descriptor for a failed list load, keyed by `ApiHttpError.status`.
 *
 * Returns a descriptor rather than a resolved string so the caller can resolve it through
 * `useLingui()` and therefore re-render on a locale switch — a lib-level `i18n._` would freeze the
 * text at first render. Pure and React-free.
 */
export function listViewErrorDescriptor(error: unknown): MessageDescriptor {
  const status = error instanceof ApiHttpError ? error.status : undefined;
  return (
    (status === undefined ? undefined : LIST_VIEW_ERROR_MESSAGES[status]) ??
    LIST_VIEW_MESSAGES.fallbackError
  );
}
